var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/giftList" } } },
                [_c("div", { staticClass: "div2" }, [_vm._v("赠品列表")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.show3,
                expression: "!show3",
              },
            ],
            staticClass: "query",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", [_vm._v("选择赠品")]),
              _c(
                "p",
                {
                  on: {
                    click: function ($event) {
                      _vm.show3 = true
                    },
                  },
                },
                [_vm._v("收起")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "polling" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      inline: true,
                      model: _vm.goods,
                      "label-width": "",
                      size: "mini",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "产品名称" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入产品名称" },
                          model: {
                            value: _vm.goods.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.goods, "name", $$v)
                            },
                            expression: "goods.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "产品编号" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入产品编号" },
                          model: {
                            value: _vm.goods.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.goods, "code", $$v)
                            },
                            expression: "goods.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择品牌" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择产品品牌",
                              clearable: "",
                              "default-first-option": "",
                            },
                            model: {
                              value: _vm.goods.brand,
                              callback: function ($$v) {
                                _vm.$set(_vm.goods, "brand", $$v)
                              },
                              expression: "goods.brand",
                            },
                          },
                          _vm._l(_vm.brandselect, function (items) {
                            return _c("el-option", {
                              key: items.id,
                              attrs: { label: items.name, value: items.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "品牌分类" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.options,
                            props: {
                              checkStrictly: true,
                              label: "name",
                              value: "id",
                              children: "children",
                            },
                            clearable: "",
                          },
                          model: {
                            value: _vm.goods.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.goods, "category", $$v)
                            },
                            expression: "goods.category",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门选择" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "选择部门", clearable: "" },
                            model: {
                              value: _vm.goods.team,
                              callback: function ($$v) {
                                _vm.$set(_vm.goods, "team", $$v)
                              },
                              expression: "goods.team",
                            },
                          },
                          _vm._l(_vm.logisticsCont, function (itemsS) {
                            return _c("el-option", {
                              key: itemsS.dictId,
                              attrs: {
                                label: itemsS.dictName,
                                value: itemsS.dictId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上架与否" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "已上架", clearable: "" },
                            model: {
                              value: _vm.goods.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.goods, "status", $$v)
                              },
                              expression: "goods.status",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "上架", value: "0" },
                            }),
                            _c("el-option", {
                              attrs: { label: "下架", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchEvent.apply(null, arguments)
                              },
                              click: function ($event) {
                                return _vm.searchEvent()
                              },
                            },
                          },
                          [_vm._v("搜索商品")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { plain: "", icon: "el-icon-refresh" },
                            on: { click: _vm.reset },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "div",
            { staticClass: "btns" },
            [
              _vm.parArray.indexOf("complimentaryAdd") != -1
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.addgoodGift },
                    },
                    [_vm._v("添加赠品")]
                  )
                : _vm._e(),
              _vm.show3
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.show3 = false
                        },
                      },
                    },
                    [_vm._v("搜索展开")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              attrs: {
                data: _vm.tableData.list,
                align: "center",
                "cell-style": { padding: "4px" },
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "seq", title: "序号", width: "50" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "赠品图片", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.image
                          ? _c("img", {
                              attrs: {
                                src: _vm.img(scope.row.image),
                                alt: "图片",
                                width: "100",
                                height: "100",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { field: "code", title: "赠品编号", "min-width": "100" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "title",
                  title: "赠品名称",
                  "show-overflow": "",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "brandId",
                  title: "赠品品牌",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "categoryId",
                  title: "赠品分类",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "sellPrice",
                  title: "赠品单价",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "specificationName",
                  title: "赠品规格",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "quantityStock",
                  title: "可用库存",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "securityIdName",
                  title: "销售权限",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "statusName",
                  title: "状态",
                  "min-width": "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "updatedTime",
                  title: "更新时间",
                  width: "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: { fixed: "right", title: "操作", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "编辑",
                              placement: "top-start",
                            },
                          },
                          [
                            _vm.parArray.indexOf("zpEdit") != -1
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "operation",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toGiftDetail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 编辑 ")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "排列向上移动",
                              placement: "top-start",
                            },
                          },
                          [
                            _vm.parArray.indexOf("zptop") != -1
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "operation",
                                    on: {
                                      click: function ($event) {
                                        return _vm.top(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 上移 ")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "排列向下移动",
                              placement: "top-start",
                            },
                          },
                          [
                            _vm.parArray.indexOf("zpbottom") != -1
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "operation",
                                    on: {
                                      click: function ($event) {
                                        return _vm.bottom(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 下移 ")]
                                )
                              : _vm._e(),
                          ]
                        ),
                        scope.row.status == 0
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "下架",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("zpxj") != -1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "operation",
                                        on: {
                                          click: function ($event) {
                                            return _vm.undercarriage(
                                              scope.row,
                                              1
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("下架 ")]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        scope.row.status == 1
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "上架",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("zpsj") != -1
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "operation",
                                        on: {
                                          click: function ($event) {
                                            return _vm.undercarriage(
                                              scope.row,
                                              0
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("上架 ")]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        !scope.row.top
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "置顶",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "operation",
                                    on: {
                                      click: function ($event) {
                                        return _vm.topButton(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 置顶")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        scope.row.top
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "取消置顶",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "operation",
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelTopButton(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("取消置顶 ")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "30px" } }),
      _vm.tableData.totalNum > 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage1,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }